import { useState, useEffect } from 'react';

const useIsLaptopScreen = (maxWidth = 1680) => {
  const [isLaptopScreen, setIsLaptopScreen] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= maxWidth : false
  );

  useEffect(() => {
    const checkIsLaptop = () => {
      setIsLaptopScreen(window.innerWidth <= maxWidth);
    };

    window.addEventListener('resize', checkIsLaptop);

    // Call it immediately in case the screen size changes before first resize
    checkIsLaptop();

    // Cleanup listener on unmount
    return () => window.removeEventListener('resize', checkIsLaptop);
  }, [maxWidth]);

  return isLaptopScreen;
};

export default useIsLaptopScreen;
